import { Navigate } from 'react-router';

import { DEFAULT_LOCALE, detectLocale } from '../i18n/config';

/** `/` in the dev server. In builds, the prerendered dist/index.html does the same redirect. */
export function RootRedirect() {
  const locale =
    typeof navigator === 'undefined' ? DEFAULT_LOCALE : detectLocale(navigator.languages);
  return <Navigate to={`/${locale}/`} replace />;
}
